"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMessageOption')(function discardMessageOption(state) {
    var optionState = state.optionState;
    optionState.soundNotify = null;
    optionState.emailToastNotify = null;
    optionState.emptyDeletedItemsOnLogOut = null;
}));
//# sourceMappingURL=discardMessageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/actions/discardMessageOption.js
// module id = 5053
// module chunks = 2